import { Status } from '../typings/chat';
import { MessageOrigin, MessageTypes, MessageTypesEnum } from '../typings/message-types';

export const shouldIgnoreMessageError = (status: Status) => {
  return status === Status.DELIVERED || status === Status.READ;
};

/**
 * Determines if a message can be forwarded based on various conditions
 * @param params - Object containing message properties and context
 * @returns boolean - true if message is forwardable, false otherwise
 */
export const isMessageForwardable = (params: {
  waGroup: boolean;
  group?: boolean;
  messageOriginType?: MessageOrigin;
  message?: MessageTypes;
}): boolean => {
  const { waGroup, group, messageOriginType, message } = params;

  // Early returns for non-forwardable scenarios
  if (waGroup || group || !message?.messageType) return false;
  if (messageOriginType === MessageOrigin.SYSTEM) return false;

  const msgType = message.messageType;
  const restrictedTypes = [
    MessageTypesEnum.STICKER,
    MessageTypesEnum.CALL,
    MessageTypesEnum.TEXT,
    MessageTypesEnum.REMINDER,
    MessageTypesEnum.REMINDER_TRIGGER,
    MessageTypesEnum.UNSUPPORTED,
  ];

  // If message type is not in restricted list, it's forwardable
  if (!restrictedTypes.includes(msgType)) return true;

  // Special case: TEXT messages are forwardable only if media is NOT disabled
  if (msgType === MessageTypesEnum.TEXT) {
    return !(
      ('mediaDisable' in message && message.mediaDisable === true) ||
      ('textDisable' in message && message.textDisable === true)
    );
  }

  // STICKER, CALL, and UNSUPPORTED messages are not forwardable
  return false;
};
